import { useMemo } from 'react';
import { LoadingType } from '@/components/common/PageLoader';

interface UseUniformLoadingProps {
  loading?: boolean;
  type?: LoadingType;
  message?: string;
  count?: number;
  fullScreen?: boolean;
}

interface LoadingConfig {
  shouldShowLoader: boolean;
  loaderProps: {
    type: LoadingType;
    message: string;
    count: number;
    fullScreen: boolean;
  };
}

export const useUniformLoading = ({
  loading = false,
  type = 'spinner',
  message = 'Loading...',
  count = 4,
  fullScreen = false
}: UseUniformLoadingProps = {}): LoadingConfig => {
  const loaderProps = useMemo(() => ({
    type,
    message,
    count,
    fullScreen
  }), [type, message, count, fullScreen]);

  return {
    shouldShowLoader: loading,
    loaderProps
  };
};

// Predefined loading configurations for common page types
export const loadingConfigs = {
  page: { type: 'spinner' as LoadingType, message: 'Loading page...', fullScreen: false },
  dashboard: { type: 'card-grid' as LoadingType, message: 'Loading dashboard...', count: 6 },
  table: { type: 'table' as LoadingType, message: 'Loading data...', count: 5 },
  form: { type: 'skeleton' as LoadingType, message: 'Loading form...', count: 3 },
  minimal: { type: 'minimal' as LoadingType, message: 'Loading...' },
  admin: { type: 'card-grid' as LoadingType, message: 'Loading admin panel...', count: 4 }
} as const;

export type LoadingConfigKey = keyof typeof loadingConfigs;